import React from "react";

const CuentaBancariaIcon = () => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0.5L0 6.92857V9.5H24V6.92857M17.6842 12.0714V21.0714H21.4737V12.0714M0 27.5H24V23.6429H0M10.1053 12.0714V21.0714H13.8947V12.0714M2.52632 12.0714V21.0714H6.31579V12.0714H2.52632Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default CuentaBancariaIcon;
